import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'reactstrap'

export default function InfoButton({ className, children, text, placement, fade }) {
  const [open, setOpen] = useState(false)
  const [ref, setRef] = useState(null)

  const toggle = () => setOpen(!open)

  return (
    <>
      <span ref={setRef} className={className} data-toggle="modal-lite" data-testid="infobutton">
        {children ? children : 'i'}
      </span>
      {ref && (
        <Tooltip
          container={ref}
          boundariesElement={ref}
          placement={placement}
          isOpen={open}
          target={ref}
          toggle={toggle}
          fade={fade}
          data-testid="infobutton-tooltip"
        >
          {text}
        </Tooltip>
      )}
    </>
  )
}

InfoButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  text: PropTypes.string,
  placement: PropTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end'
  ]),
  fade: PropTypes.bool
}

InfoButton.defaultProps = {
  placement: 'auto',
  fade: true
}
